import { LINECHART_DATE_RANGES_TYPE } from "./types";

const WIDGET_ID = "result-search-trends";

const DEFAULT_DATE_RANGE = "oneYear" as LINECHART_DATE_RANGES_TYPE;

export { WIDGET_ID, DEFAULT_DATE_RANGE };
